import { render, staticRenderFns } from "./NiveisAcessoReadPermissoes.vue?vue&type=template&id=529134c7&scoped=true&"
import script from "./NiveisAcessoReadPermissoes.vue?vue&type=script&lang=js&"
export * from "./NiveisAcessoReadPermissoes.vue?vue&type=script&lang=js&"
import style0 from "./NiveisAcessoReadPermissoes.vue?vue&type=style&index=0&id=529134c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529134c7",
  null
  
)

export default component.exports